<div class="tt-o-menu">
  <slot name="menuTrigger"></slot>
  <slot></slot>
</div>
